/**
 * Eingabeart merken: `html.pa-pointer`, solange zuletzt Maus/Finger benutzt wurde; Tab (Tastaturnavigation) entfernt die Klasse.
 * Grund: Browser zeigen bei Textfeldern :focus-visible auch nach einem Mausklick (Tippen wird erwartet). Mit dieser Klasse
 * können Komponenten den Fokusrahmen von Textfeldern nur bei Tastaturnavigation zeigen (Alex 25.09.2026, Ortsfeld Finder).
 * Nur Tab zählt – normales Tippen im angeklickten Feld darf den Rahmen nicht nachträglich einblenden.
 */
export function init() {
	const root = document.documentElement;
	document.addEventListener('pointerdown', () => root.classList.add('pa-pointer'), { capture: true, passive: true });
	document.addEventListener('keydown', (e) => { if (e.key === 'Tab') root.classList.remove('pa-pointer'); }, { capture: true });
}
